<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-lg>
      <ModelTitle
        title="Edit TechLocation"
        @close="close()"
        :color="$style.purchase.titlebar"
      />

      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :hide-details="nameErrors.length === 0"
              outlined
              dense
              :error-messages="nameErrors"
              v-model="techLocation.name"
              ref="techLocationName"
              label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="techLocation.contactName"
              label="Contact Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="techLocation.phoneNumber"
              label="Phone Number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="techLocation.email"
              label="Email Address"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="techLocation.address"
              label="Address"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="techLocation.city"
              label="City"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="techLocation.state"
              label="State"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="techLocation.zip"
              label="Zip Code"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              outlined
              dense
              hide-details
              auto-grow
              v-model="techLocation.description"
              :label="$t('labels.description')"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import techLocationService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTechLocation: {
      type: Object,
    },
  },
  name: "update-techLocation",
  data() {
    return {
      loading: false,
      dialog: false,
      techLocation: {
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    techLocation: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.techLocation.name.$dirty) return errors;
      if (!this.$v.techLocation.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      if (val) {
        this.techLocation = this.editTechLocation;
        this.$nextTick(() => {
          this.$refs.techLocationName.focus();
        });
      }
      this.dialog = val;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.techLocation = {
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return techLocationService
          .update(this.techLocation.id, this.techLocation)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "techLocation is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
